export default {
  header: {
    switch: {
      '/zh-CN': '切换主题色',
      '/en-US': 'Change Theme Color'
    },
    download: {
      '/zh-CN': '下载主题',
      '/en-US': 'Download Theme'
    },
    help: {
      '/zh-CN': '帮助',
      '/en-US': 'Help'
    },
    versionName: {
      '/zh-CN': 'Element UI版本',
      '/en-US': 'Element UI version'
    }
  },
  menu: {
    revoke: {
      '/zh-CN': '撤销',
      '/en-US': 'Revoke'
    },
    reset: {
      '/zh-CN': '重置',
      '/en-US': 'Reset'
    },
    download: {
      '/zh-CN': '下载',
      '/en-US': 'Download'
    }
  },
  form: {
    theme: {
      '/zh-CN': '主题色',
      '/en-US': 'Theme color'
    },
    switch: {
      '/zh-CN': '切换',
      '/en-US': 'Change'
    },
    reset: {
      '/zh-CN': '重置',
      '/en-US': 'Reset'
    }
  },
  validate: {
    required: {
      '/zh-CN': '颜色不能为空',
      '/en-US': 'color is required'
    },
    format: {
      '/zh-CN': '请输入 hex 格式的主题色',
      '/en-US': 'Theme color should be in hex format'
    }
  },
  help: {
    title: {
      '/zh-CN': '帮助',
      '/en-US': 'Help'
    },
    content: {
      '/zh-CN': `
        <p>1、此时本页面会按照你选定的主题色重新生成样式，你可以预览应用了新主题色的 Element；</p>
        <p>2、点击菜单栏中的「下载」，会自动下载应用了新主题色的样式文件；</p>
        <p>3、点击菜单栏中的[重置]，会重置主题色为默认值，恢复到页面加载时的状态；</p>
        <p>4、点击菜单栏中的[撤销]，会撤销当前组件的默认样式；</p>
        <p>5、关于如何在项目中引入新的样式文件，请参考官方文档中<a href="http://element.eleme.io/#/zh-CN/component/custom-theme#yin-ru-zi-ding-yi-zhu-ti" target="_blank">自定义主题</a>的相关内容；</p>
        <p>注意：本页面仅用来预览主题，页面上的元素不含交互逻辑。</p>
      `,
      '/en-US': `
        <p>1. Now this page will apply a new style generated with your newly appointed theme color, so you can preview what Element looks like once this color is applied;</p>
        <p>2. Click the 'Download Theme' button on the header menu, and you can download the style files with the new theme color;</p>
        <p>3. Click [Reset] in the menu bar to reset the theme color to the default value and restore it to the state when the page was loaded</p>
        <p>4. Clicking on [Cancel] in the menu bar will undo the default style of the current component</p>
        <p>5. To import new style files in your project, please refer to the <a href="http://element.eleme.io/#/en-US/component/custom-theme#import-custom-theme" target="_blank">custom theme</a> section in our official documentation;</p>
        <p>Note that this page is only for previewing themes, so the components on this page are not interactive.</p>
      `
    },
    ok: {
      '/zh-CN': '确定',
      '/en-US': 'OK'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang.js